import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';
import { CustomDatePickerComponent } from './custom-datepicker/custom-datepicker';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ZoomAreaModule } from 'ionic2-zoom-area';


@NgModule({
    declarations: [
        CustomDatePickerComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        // ZoomAreaModule.forRoot()
    ],
    exports: [
        CustomDatePickerComponent
    ],
    providers: [

    ],
    entryComponents: [
        CustomDatePickerComponent
    ]
})

export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/component/component.module.ts